module.exports = __webpack_public_path__ + "static/media/default-vod-horizontal-poster.d925bf2f.png";